export default (id, resizing) => ({
  type: "SECTIONS/NODE/RESIZING",
  payload: { id, resizing }
});
